export default "__VITE_ASSET__D$MkuAzB__"